module.exports = function getResource (label, vars = []) {
    const resources = {
        confirmBasketUpdateModalTitle: 'Confirmation',
        confirmBasketUpdateModalButtonText: 'Continuer',
        sureToContinueMessage: 'Souhaitez-vous vraiment continuer?',
        error: 'Erreur',
        ok: 'OK'
    };
    return resources[label];
};
